import { render, staticRenderFns } from "./BeeLabel.vue?vue&type=template&id=2f8b7326"
import script from "./BeeLabel.vue?vue&type=script&lang=js"
export * from "./BeeLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports